var _path, _line, _line2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path11, _rect, _path12, _path13, _path14, _path15, _path16, _circle2, _circle3, _path17, _line3, _line4, _line5, _line6, _circle4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRogoErrorSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 255.4,
    height: 223.178,
    viewBox: "0 0 255.4 223.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100.823 -399.582)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.282,582.23a23.064,23.064,0,0,0-21.449,14.624,23.041,23.041,0,0,0,42.9,0A23.062,23.062,0,0,0,329.282,582.23Zm0,24.374a9.749,9.749,0,1,1,9.75-9.75A9.753,9.753,0,0,1,329.282,606.6Zm0-15.6a5.85,5.85,0,1,0,5.85,5.849A5.841,5.841,0,0,0,329.282,591Z",
    transform: "translate(5.491 4.819)",
    fill: "#101b35"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 83.219,
    x2: 21.056,
    transform: "translate(256.406 528.502)",
    fill: "#061e3b",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 81.095,
    x2: 20.518,
    transform: "translate(296.593 539.673)",
    fill: "#061e3b",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M309.724,551.341c-2.1,17.558-6.135,33.121-11.689,46.2l-41.327-10.456c.363-9.741,4.89-33.1,11.689-46.2Z",
    transform: "translate(4.135 3.722)",
    fill: "#101b35",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(254.174 420.383)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.792,433.122l-16.522-.038a.408.408,0,0,0-.41.406l.031-13.209a.408.408,0,0,0-.657-.324L250.37,449.339a.409.409,0,0,0,0,.645l34.724,29.767a.408.408,0,0,0,.66-.32l.031-13.206a.409.409,0,0,0,.408.41l16.523.039a.409.409,0,0,0,.41-.408l.076-32.734A.408.408,0,0,0,302.792,433.122Z",
    transform: "translate(-250.212 -419.871)",
    fill: "#101b35"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M302.792,433.122l-16.522-.038a.408.408,0,0,0-.41.406l.031-13.209a.408.408,0,0,0-.657-.324L250.37,449.339a.409.409,0,0,0,0,.645l34.724,29.767a.408.408,0,0,0,.66-.32l.031-13.206a.409.409,0,0,0,.408.41l16.523.039a.409.409,0,0,0,.41-.408l.076-32.734A.408.408,0,0,0,302.792,433.122Z",
    transform: "translate(-250.212 -419.871)",
    fill: "#101b35"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.08)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M302.792,433.2l-16.523-.038a.407.407,0,0,0-.409.408l.031-13.21a.408.408,0,0,0-.658-.324L250.37,449.417a.408.408,0,0,0,0,.645l34.724,29.768a.408.408,0,0,0,.66-.32l.031-13.206a.408.408,0,0,0,.408.409l16.523.039a.408.408,0,0,0,.409-.408l.077-32.734A.408.408,0,0,0,302.792,433.2Z",
    transform: "translate(-250.211 -419.949)",
    fill: "#101b35"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.08)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M302.792,433.2l-16.523-.038a.407.407,0,0,0-.409.408l.031-13.21a.408.408,0,0,0-.658-.324L250.37,449.417a.408.408,0,0,0,0,.645l34.724,29.768a.408.408,0,0,0,.66-.32l.031-13.206a.408.408,0,0,0,.408.409l16.523.039a.408.408,0,0,0,.409-.408l.077-32.734A.408.408,0,0,0,302.792,433.2Z",
    transform: "translate(-250.211 -419.949)",
    fill: "#101b35"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.08)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M302.792,433.2l-16.523-.038a.407.407,0,0,0-.409.408l.031-13.21a.408.408,0,0,0-.658-.324L250.37,449.417a.408.408,0,0,0,0,.645l34.724,29.768a.408.408,0,0,0,.66-.32l.031-13.206a.408.408,0,0,0,.408.409l16.523.039a.408.408,0,0,0,.409-.408l.077-32.734A.408.408,0,0,0,302.792,433.2Z",
    transform: "translate(-250.211 -419.949)",
    fill: "#101b35"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M302.792,433.122l-16.522-.038a.408.408,0,0,0-.41.406l.031-13.209a.408.408,0,0,0-.657-.324L250.37,449.339a.409.409,0,0,0,0,.645l34.724,29.767a.408.408,0,0,0,.66-.32l.031-13.206a.409.409,0,0,0,.408.41l16.523.039a.409.409,0,0,0,.41-.408l.076-32.734A.408.408,0,0,0,302.792,433.122Z",
    transform: "translate(-250.212 -419.871)",
    fill: "#101b35"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M302.792,433.122l-16.522-.038a.408.408,0,0,0-.41.406l.031-13.209a.408.408,0,0,0-.657-.324L250.37,449.339a.409.409,0,0,0,0,.645l34.724,29.767a.408.408,0,0,0,.66-.32l.031-13.206a.409.409,0,0,0,.408.41l16.523.039a.409.409,0,0,0,.41-.408l.076-32.734A.408.408,0,0,0,302.792,433.122Z",
    transform: "translate(-250.212 -419.871)",
    fill: "#101b35"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.122,
    cy: 47.122,
    r: 47.122,
    transform: "translate(239.216 403.245)",
    fill: "none",
    stroke: "#101b35",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.823,601.263",
    transform: "translate(0 5.323)",
    fill: "#061e3b",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.19 479.02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.854,478.675l-2.169-.016-3.094-1.056h-15l-7.584.808-.064-.606,7.616-.809,15.135,0,3.142,1.072h1.946l3.238-.791,9.523.255-.017.61-9.441-.253Z",
    transform: "translate(-147.94 -476.993)",
    fill: "#061e3b",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.909 1.359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.812,479.19l-.038-.609,4.2-.263h4.795v.61H155Z",
    transform: "translate(-150.774 -478.317)",
    fill: "#061e3b",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.839 1.279)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.487,
    height: 0.61,
    fill: "#061e3b",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.705 1.279)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.888,
    height: 0.61,
    fill: "#061e3b",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.884 450.471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.151,449.182",
    transform: "translate(-166.151 -449.182)",
    fill: "#061e3b",
    stroke: "#1a1818",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.653 474.974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.159,473.052",
    transform: "translate(-157.159 -473.052)",
    fill: "#061e3b",
    stroke: "#1a1818",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.653 472.21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.159,470.359",
    transform: "translate(-157.159 -470.359)",
    fill: "#061e3b",
    stroke: "#1a1818",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(186.584 475.455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.368,473.52",
    transform: "translate(-184.368 -473.52)",
    fill: "#061e3b",
    stroke: "#1a1818",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(186.584 470.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.368,468.683",
    transform: "translate(-184.368 -468.683)",
    fill: "#061e3b",
    stroke: "#1a1818",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.147 400.582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.876,569.355a14,14,0,0,1-5.634-1.11c-19.691-8.95-23.233-32.473-24.746-42.517-.219-1.451-.391-2.6-.565-3.406-1.576-7.355-4.859-48.823,3.307-84.752,2.375-10.452,7.456-24.529,18.171-32.231,6.458-4.643,11.836-4.755,12.062-4.758,10.263.2,18.669,6.976,24.326,19.6a76.872,76.872,0,0,1,5.432,18.712c2.379.159,6.082.53,6.947,1.315a.5.5,0,0,1,.162.36v.038l.236,9.8-.995.025-.23-9.582c-.563-.274-2.414-.73-6.561-.985a.5.5,0,0,1-.27-.1l-.03-.023a.494.494,0,0,1-.193-.334,75.346,75.346,0,0,0-5.417-18.836c-5.566-12.414-13.442-18.8-23.413-19-.037,0-5.327.124-11.539,4.615-10.422,7.533-15.389,21.341-17.72,31.6-8.13,35.77-4.871,77.012-3.3,84.323.18.84.355,2,.576,3.466,1.488,9.885,4.976,33.034,24.175,41.76,1.236.563,7.775,3.059,15.655-2.679.564-2.053,3.742-11.38,4.183-16.326l.99.088c-.47,5.274-4.01,15.758-4.26,16.668a.5.5,0,0,1-.184.268A18.6,18.6,0,0,1,141.876,569.355Z",
    transform: "translate(-108.932 -400.582)",
    fill: "#051e3b",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.974 413.805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.425,555.587c-4.91,0-9.717-7.116-9.946-7.459-6.87-11.012-10.563-28.68-10.986-52.529a328.484,328.484,0,0,1,2.32-42.867,90.881,90.881,0,0,1,7.137-24.394c3.081-6.708,8.006-14.734,13.973-14.872,4.437-.115,8.424,4.222,11.838,12.858a82.908,82.908,0,0,1,3.775,12.81.5.5,0,0,1-.068.36.538.538,0,0,1-.376.246,11.124,11.124,0,0,0-3.514.756l-.048,9.315.02.024a.5.5,0,1,1-.769.629,1,1,0,0,1-.245-.639l.049-9.547a.536.536,0,0,1,.17-.425,8.156,8.156,0,0,1,3.7-1.037c-.761-3.543-5.61-24.358-14.378-24.358l-.129,0c-4.256.1-8.906,5.175-13.094,14.293a89.827,89.827,0,0,0-7.052,24.1,327.45,327.45,0,0,0-2.314,42.731c.42,23.667,4.063,41.164,10.828,52.008.05.076,5.617,7.8,10.707,6.658a9.554,9.554,0,0,0,6.948-6.387.5.5,0,0,1,.637-.3.51.51,0,0,1,.3.637,9.9,9.9,0,0,1-7.341,7.112A7.324,7.324,0,0,1,141.425,555.587Z",
    transform: "translate(-120.453 -413.463)",
    fill: "#051e3b",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(146.823 451.396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.626,548.648c-3.423,0-17.9-2.026-18.514-2.113a.553.553,0,0,1-.477-.549V532.331a.555.555,0,0,1,.07-.271l1.054-1.885a.548.548,0,0,1,.324-.261l2.291-.687.433-3.254-.5-.335a.556.556,0,0,1-.242-.536c.013-.1,1.312-9.747,1.312-13.1V479.844l-1.878-.208a.533.533,0,0,1-.186-.055l-1.054-.527a.556.556,0,0,1-.307-.5V476.45a.557.557,0,0,1,.093-.308l.528-.79a.556.556,0,0,1,.428-.245l3.956-.233V473.58h-.236a.554.554,0,0,1-.554-.554v-3.082l-.22-.11a.555.555,0,0,1-.307-.507l.263-12.38a.555.555,0,0,1,.447-.532l.872-.174v-1.389a.556.556,0,0,1,.246-.462,8.319,8.319,0,0,1,2.386-1.084l-.008-1.278c-2.361-.479-2.361-1.134-2.361-1.391a.554.554,0,0,1,1.078-.183,5.464,5.464,0,0,0,1.793.542.564.564,0,0,1,.435.162.589.589,0,0,1,.161.495l.011,1.852a.864.864,0,0,1-.749.862,6.073,6.073,0,0,0-1.884.79V456.7a.554.554,0,0,1-.446.543l-.882.177L151.754,469l.214.106a.555.555,0,0,1,.306.5v2.869h.236a.555.555,0,0,1,.554.554V475.4a.554.554,0,0,1-.521.553l-4.2.247-.28.421v1.6l.659.329,2.272.253a.554.554,0,0,1,.494.55v32.661c0,3.1-1.04,11.113-1.277,12.9l.5.336a.553.553,0,0,1,.242.534l-.527,3.951a.557.557,0,0,1-.391.458l-2.419.726-.874,1.562V545.5c2.585.357,14.877,2.036,17.883,2.036,2.988,0,13.8-.822,16.263-1.013l1.093-66.661a.555.555,0,0,1,.482-.541l5.575-.727v-4.989l-5.3-.558a.553.553,0,0,1-.5-.551V458.74l-1.189-1.426a.55.55,0,0,1-.128-.318l-.113-1.694c-.495-.312-1.343-.835-1.689-1.008-.225-.112-.825-.412-.58-2.8a.556.556,0,0,1,.467-.492,7,7,0,0,0,2.21-.554.554.554,0,0,1,1.076.188c0,.667-.736,1.057-2.684,1.392a3.813,3.813,0,0,0,.075,1.308c.587.307,1.9,1.141,1.958,1.178a.554.554,0,0,1,.256.431l.12,1.8,1.2,1.442a.555.555,0,0,1,.128.355V472l5.3.558a.554.554,0,0,1,.5.551v5.974a.555.555,0,0,1-.483.549l-5.583.729-1.093,66.686a.555.555,0,0,1-.511.544C180.931,547.636,168.033,548.648,164.626,548.648Z",
    transform: "translate(-145.634 -450.083)",
    fill: "#061e3b",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.92 439.122)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.23,439.162l-.068-.606a94.119,94.119,0,0,1,9.811-.43c2.246,0,4.4.062,6.391.185l-.038.609c-1.982-.122-4.119-.184-6.353-.184A93.727,93.727,0,0,0,157.23,439.162Z",
    transform: "translate(-157.162 -438.126)",
    fill: "#061e3b",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.563,450.978a.3.3,0,0,1-.3-.267c-.441-.542-5.643-1.314-14.053-1.314s-13.612.772-14.052,1.314a.305.305,0,0,1-.608-.039c0-.3,0-.928,4.476-1.421a112,112,0,0,1,20.368,0c4.476.493,4.476,1.12,4.476,1.421A.306.306,0,0,1,181.563,450.978Zm-.3-.306h0Zm-28.1,0h0Z",
    transform: "translate(-152.548 -448.787)",
    fill: "#061e3b",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.599 12.655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.455,451.7l-.375-.481c.94-.741,10.689-.763,11.8-.763,3.257,0,6.264.07,8.466.2,3.826.22,3.826.5,3.826.827h-.61a.225.225,0,0,0,.08.178c-.453-.29-4.977-.59-11.762-.59C159.643,451.065,155.843,451.434,155.455,451.7Z",
    transform: "translate(-155.08 -450.454)",
    fill: "#061e3b",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.975 15.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.046,454.04c-.422-.277-4.835-.662-12.021-.662s-11.6.385-12.022.662a.225.225,0,0,0,.079-.177h-.611c0-.315,0-.614,3.873-.863,2.32-.15,5.4-.232,8.68-.232s6.36.082,8.68.232c3.872.249,3.872.548,3.872.863h-.61A.225.225,0,0,0,179.046,454.04Z",
    transform: "translate(-154.472 -452.768)",
    fill: "#061e3b",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(163.628 500.67)",
    style: {
      isolation: "isolate"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M171.833,500.555h-3.091a.076.076,0,0,0-.076.077V498.16a.076.076,0,0,0-.123-.06l-6.508,5.511a.076.076,0,0,0,0,.12l6.509,5.554a.076.076,0,0,0,.123-.061v-2.47a.076.076,0,0,0,.076.076h3.091a.077.077,0,0,0,.077-.076v-6.123A.077.077,0,0,0,171.833,500.555Z",
    transform: "translate(-162.005 -498.084)",
    fill: "#051e3b"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.671,
    height: 4.509,
    transform: "translate(146.139 581.427) rotate(42.049)",
    fill: "#101b35",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M161.832,479.869l-1.324.079-1.46-1.884h2.783Z",
    transform: "translate(1.545 2.055)",
    fill: "#111b35"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M194.523,561.01",
    transform: "translate(2.486 4.256)",
    fill: "#061e3b",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M153.156,559.513c-8.561,32.965-46.146,36.393-46.146,36.393",
    transform: "translate(0.164 4.216)",
    fill: "none",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M163.8,568.309c-9.959,32.818-47.735,38.452-47.735,38.452",
    transform: "translate(0.404 4.449)",
    fill: "none",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M162.568,568.923c2.858-9.683,3.474-11.349,5.505-23.766",
    transform: "translate(1.638 3.835)",
    fill: "none",
    stroke: "#111b35",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.581,
    cy: 13.581,
    r: 13.581,
    transform: "translate(156.598 492.698)",
    fill: "none",
    stroke: "#101b35",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.581,
    cy: 13.581,
    r: 13.581,
    transform: "translate(134.438 572.758)",
    fill: "none",
    stroke: "#101b35",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M312.892,607.391a47,47,0,1,1,15.327-25.444",
    transform: "translate(3.562 3.287)",
    fill: "none",
    stroke: "#101b35",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 80.307,
    x2: 93.139,
    transform: "translate(161.035 415.93)",
    fill: "none",
    stroke: "#101b35",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 124.154,
    y2: 23.29,
    transform: "translate(172.321 496.403)",
    fill: "none",
    stroke: "#101b35",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: 42.207,
    x2: 124.196,
    transform: "translate(144.127 531.116)",
    fill: "none",
    stroke: "#101b35",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 129.207,
    y1: 21.22,
    transform: "translate(147.347 599.884)",
    fill: "none",
    stroke: "#101b35",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.145,
    cy: 24.145,
    r: 24.145,
    transform: "translate(144.303 482.039)",
    fill: "#e50019",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.145,
    cy: 24.145,
    r: 24.145,
    transform: "translate(124.074 562.903)",
    fill: "#e50019",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRogoErrorSvg);
export default __webpack_public_path__ + "static/media/rogo_error_svg.c4e30a90c28c983e8e26f2cc7c379c1a.svg";
export { ForwardRef as ReactComponent };